/**
 * It takes a string, replaces all instances of a lowercase letter followed by an uppercase letter with
 * a space between them, and returns the result
 * @param {string} value - string - The string that we want to put spaces between words in.
 */
export const putSpaceBetweenWords = (value: string) => {
  return value.replace(/([a-z])([A-Z])/g, '$1 $2');
};
